module.exports = __webpack_public_path__ + "static/media/Miraji-book-geeta.a9933493.jpg";